var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2109 19.2891L12.0234 13.0547L5.78906 19.2891C5.50781 19.5703 5.03906 19.5703 4.71094 19.2891C4.42969 18.9609 4.42969 18.4922 4.71094 18.2109L10.9453 11.9766L4.71094 5.78906C4.42969 5.50781 4.42969 5.03906 4.71094 4.71094C5.03906 4.42969 5.50781 4.42969 5.78906 4.71094L12.0234 10.9453L18.2109 4.71094C18.4922 4.42969 18.9609 4.42969 19.2891 4.71094C19.5703 5.03906 19.5703 5.50781 19.2891 5.78906L13.0547 11.9766L19.2891 18.2109C19.5703 18.4922 19.5703 18.9609 19.2891 19.2891C18.9609 19.5703 18.4922 19.5703 18.2109 19.2891Z",
    fill: "#232639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.d9f4363780fa46fe852330c05ac87653.svg";
export { ForwardRef as ReactComponent };